<template>
  <LayoutGradient :title="$t('interopera.transmissao.titulo_pagina')" icon="fa-broadcast-tower">
    <div class="row m-3 mt-n10">
      <div class="col-lg-6 p-3">
        <b-card>
          <SimpleForm @submit="onSubmit" :fields="fields" :model="model"/>
        </b-card>
      </div>
      <div class="col-lg-6 p-3">
        <b-card :title="$t('interopera.transmissao.importacao_massa')">
          <b-card-body>
            <b-overlay :show="construcao" variant="white" spinner-variant="white">
              <template v-slot:overlay>
                <div class="text-center">
                  <p>{{ $t('interopera.transmissao.funcionalidade_contrucao') }}</p>
                  <b-button variant="outline-info" size="sm" @click="construcao = false">Okay</b-button>
                </div>
              </template>
              <b-form-file :placeholder="$t('interopera.transmissao.escolha_arquivo_importacao')"
                           :drop-placeholder="$t('interopera.transmissao.arraste_solte_arquivo')"
                           :browse-text="$t('interopera.transmissao.selecionar')"
                           v-model="model_bulk.file"/>
              <FieldGenerator class="mt-4" :field="{
                label: $t('interopera.transmissao.separador'),
                name: 'separador',
                type: 'select',
                options:[
                  {value: 'tab', text: $t('interopera.transmissao.arquivo_importacao_valores.tab')},
                  {value: 'pipe', text: $t('interopera.transmissao.arquivo_importacao_valores.pipe')},
                  {value: 'space', text: $t('interopera.transmissao.arquivo_importacao_valores.espaco')},
                  {value: 'comma', text: $t('interopera.transmissao.arquivo_importacao_valores.virgula')},
                  {value: 'dot', text: $t('interopera.transmissao.arquivo_importacao_valores.ponto')},
                ]
              }" :model="model_bulk"/>
              <FieldGenerator class="mt-4" :field="{
                label: $t('interopera.transmissao.quantidade_coluna'),
                name: 'fieldsQuantity',
                type: 'number'
              }" :model="model_bulk"/>
              <b-button variant="success" type="button" block>
              <i class="fas fa-save"/> {{ $t('interopera.transmissao.importar') }}</b-button>

            </b-overlay>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </LayoutGradient>
</template>

<script>
import {mapActions} from "vuex";
import LayoutGradient from "@/templates/LayoutGradient";
import SimpleForm from "@/components/FormGenerator/SimpleForm";
import FieldGenerator from "@/components/FormGenerator/FieldGenerator";
import InteroperaRepository from "@/repositories/InteroperaRepository";

export default {
  name: "Form",
  components: {FieldGenerator, SimpleForm, LayoutGradient},
  data() {
    return {
      construcao: true,
      fields: [
        {label: this.$t('interopera.transmissao.campos.id_resultado_label'), name: 'result_id', description:this.$t('interopera.transmissao.campos.id_resultado_label'), required: true},
        {label: this.$t('interopera.transmissao.campos.cpf_label'), name: 'patient_identifier', description:this.$t('interopera.transmissao.campos.cpf_descricao'), required: true},
        {label: this.$t('interopera.transmissao.campos.nome_label'), name: 'patient_name', description: this.$t('interopera.transmissao.campos.nome_descricao'), required: true},
        {label: this.$t('interopera.transmissao.campos.data_nascimento_label'), name: 'birthDate', type: 'date', description: this.$t('interopera.transmissao.campos.data_nascimento_descricao'), required: true},
        {
          label: this.$t('interopera.transmissao.campos.genero_label'), name: 'gender', description:this.$t('interopera.transmissao.campos.genero_descricao'), type: 'select', required: true, options: [
            {value: 'male', text: this.$t('interopera.transmissao.campos.genero_valores.masculino')},
            {value: 'female',   text: this.$t('interopera.transmissao.campos.genero_valores.feminino')}
          ]
        },
        {label: this.$t('interopera.transmissao.campos.endereco_label'), name: 'patient_address', description: this.$t('interopera.transmissao.campos.endereco_descricao'), required: true},
        {label: this.$t('interopera.transmissao.campos.cep_label'), name: 'postalCode', description: this.$t('interopera.transmissao.campos.cep_descricao'), required: true},        
        {
          label: this.$t('interopera.transmissao.campos.exame_label'), name: 'code', type: 'select', required: true, options: [
            {value: 'CVIDGG', text: 'COVID-19, IgG'}            
          ]
        },
        {
          label: this.$t('interopera.transmissao.campos.resultado_label'), name: 'value_quantity', type: 'select', required: true, options: [
            {value: '1', text: this.$t('interopera.transmissao.campos.resultado_valores.detectavel')},
            {value: '2', text: this.$t('interopera.transmissao.campos.resultado_valores.nao_detectavel')},
            {value: '3', text: this.$t('interopera.transmissao.campos.resultado_valores.inconclusivo')},
          ]
        },
        {
          label: this.$t('interopera.transmissao.campos.amostra_biologica_label'), name: 'specimen_code', type: 'select', required: true, options: [
            /*{value: 'SECONF', text: 'Secreção Orofaríngea e Nasofaríngea'},
            {value: 'SNOF',   text: 'Swab Naso-Orofaríngeo'},
            {value: 'SWNAFA', text: 'Swab Nasofaríngeo'},
            {value: 'SWAB',   text: 'Swab'},*/
            {value: 'SWORO',  text: 'Swab Orofaríngeo'},
            // {value: 'SWNAS',  text: 'Swab Nasal'},
          ]
        },
        {label: this.$t('interopera.transmissao.campos.data_label'), name: 'processed_at', type: 'date', description: this.$t('interopera.transmissao.campos.data_descricao'), required: true},
        {
          label: this.$t('interopera.transmissao.campos.uf_laboratorio_label'), name: 'uf_company', type: 'select', required: true, options: [
            {text: "Acre", value: "AC"},
            {text: "Alagoas", value: "AL"},
            {text: "Amapá", value: "AP"},
            {text: "Amazonas", value: "AM"},
            {text: "Bahia", value: "BA"},
            {text: "Ceará", value: "CE"},
            {text: "Distrito Federal", value: "DF"},
            {text: "Espírito Santo", value: "ES"},
            {text: "Goiás", value: "GO"},
            {text: "Maranhão", value: "MA"},
            {text: "Mato Grosso", value: "MT"},
            {text: "Mato Grosso do Sul", value: "MS"},
            {text: "Minas Gerais", value: "MG"},
            {text: "Pará", value: "PA"},
            {text: "Paraíba", value: "PB"},
            {text: "Paraná", value: "PR"},
            {text: "Pernambuco", value: "PE"},
            {text: "Piauí", value: "PI"},
            {text: "Rio de Janeiro", value: "RJ"},
            {text: "Rio Grande do Norte", value: "RN"},
            {text: "Rio Grande do Sul", value: "RS"},
            {text: "Rondônia", value: "RO"},
            {text: "Roraima", value: "RR"},
            {text: "Santa Catarina", value: "SC"},
            {text: "São Paulo", value: "SP"},
            {text: "Sergipe", value: "SE"},
            {text: "Tocantins", value: "TO"}
          ]
        },
      ],
      model: {
        result_id: null,
        code: null,
        value_quantity: null,
        specimen_code: null,
        processed_at: null,
        patient_identifier: null,
        patient_name: null,
        patient_address: null,
        postalCode: null,
        gender: null,
        birthDate: null,
        uf_company: null,
      },
      model_bulk: {
        file: null,
        separador: 'comma',
        fieldsQuantity: 0,
      }
    }
  },
  methods: {
    ...mapActions([
        'corecompanies/listInVs'
    ]),
    onSubmit() {
      const params = {
        device_name: `VNSINTER`,
        filename: 'result.json',
        report_content: JSON.stringify({
          exams: [
            {
              result_id: this.model.result_id,
              code: this.model.code,
              value_quantity: this.model.value_quantity,
              processed_at: this.model.processed_at
            }
          ],
          patient_identifier: this.model.patient_identifier,
          company_id: 1, // valor fixo
          patient_name: this.model.patient_name,
          patient_address: this.model.patient_address,
          postalCode: this.model.postalCode,
          gender: this.model.gender,
          birthDate: this.model.birthDate,
          uf_company: this.model.uf_company,
          specimen_code: this.model.specimen_code,
          reference_range: null,
          method_code: null,
          note: null,
          cnes_company: "3283948293484", // valor fixo
          cns_profissional: "980016001735277",  // valor fixo
        })
      }
      InteroperaRepository.post(params).then(() => {
        this.$snotify.success(this.$t('interopera.transmissao.reporte_enviado'))
      }).catch(error => {
        this.$snotify.error(this.$t('interopera.transmissao.erro_reportar_exame'))
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
</style>